module.exports = "<svg viewBox=\"0 0 22 13\" xmlns=\"http://www.w3.org/2000/svg\"><g class=\"ProgressBar-iconFill\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M10 0h2v13h-2zM0 6h8v1H0z\"></path><path d=\"M5.5 2.964L9.036 6.5l-.708.707-3.535-3.535z\"></path><path d=\"M4.793 9.328l3.535-3.535.708.707L5.5 10.036zM22 7h-8V6h8z\"></path><path d=\"M16.5 10.036L12.964 6.5l.708-.707 3.535 3.535z\"></path><path d=\"M17.207 3.672l-3.535 3.535-.708-.707L16.5 2.964z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ProgressBarPane/size.svg
// module id = 2033
// module chunks = 0